import styled from 'styled-components';
import { Button } from '@morressier/ts';

export const Container = styled.div`
  width: 100%;
  margin: auto;
`;

export const LoadMoreButton = styled(Button)`
  margin-top: 1rem;
  width: 17.5rem;
`;
